export default __webpack_public_path__ + "static/media/partly_cloudy_night.5045ac54.svg";